/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzGetManagedPermissionsPermissionsOfGroupQueryResponse, UsersAuthzGetManagedPermissionsPermissionsOfGroupPathParams, UsersAuthzGetManagedPermissionsPermissionsOfGroup401, UsersAuthzGetManagedPermissionsPermissionsOfGroup403 } from "../models/UsersAuthzGetManagedPermissionsPermissionsOfGroup";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { usersAuthzGetManagedPermissionsPermissionsOfGroup } from "../axios/usersAuthzGetManagedPermissionsPermissionsOfGroup";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const usersAuthzGetManagedPermissionsPermissionsOfGroupQueryKey = (groupId: UsersAuthzGetManagedPermissionsPermissionsOfGroupPathParams["groupId"]) => ["api-v2", { url: '/users-authz/v1/groups/:groupId/permissions', params: {groupId:groupId} }] as const

export type UsersAuthzGetManagedPermissionsPermissionsOfGroupQueryKey = ReturnType<typeof usersAuthzGetManagedPermissionsPermissionsOfGroupQueryKey>

export function usersAuthzGetManagedPermissionsPermissionsOfGroupQueryOptions(groupId: UsersAuthzGetManagedPermissionsPermissionsOfGroupPathParams["groupId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = usersAuthzGetManagedPermissionsPermissionsOfGroupQueryKey(groupId)
        return queryOptions<UsersAuthzGetManagedPermissionsPermissionsOfGroupQueryResponse, ResponseErrorConfig<UsersAuthzGetManagedPermissionsPermissionsOfGroup401 | UsersAuthzGetManagedPermissionsPermissionsOfGroup403>, UsersAuthzGetManagedPermissionsPermissionsOfGroupQueryResponse, typeof queryKey>({
         enabled: !!(groupId),
         queryKey,
         queryFn: async ({ signal }) => {
            return usersAuthzGetManagedPermissionsPermissionsOfGroup(groupId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Get all permissions for a specific group
 * {@link /users-authz/v1/groups/:groupId/permissions}
 */
export function useUsersAuthzGetManagedPermissionsPermissionsOfGroup<TData = UsersAuthzGetManagedPermissionsPermissionsOfGroupQueryResponse, TQueryData = UsersAuthzGetManagedPermissionsPermissionsOfGroupQueryResponse, TQueryKey extends QueryKey = UsersAuthzGetManagedPermissionsPermissionsOfGroupQueryKey>(groupId: UsersAuthzGetManagedPermissionsPermissionsOfGroupPathParams["groupId"], options: 
{
  query?: Partial<QueryObserverOptions<UsersAuthzGetManagedPermissionsPermissionsOfGroupQueryResponse, ResponseErrorConfig<UsersAuthzGetManagedPermissionsPermissionsOfGroup401 | UsersAuthzGetManagedPermissionsPermissionsOfGroup403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? usersAuthzGetManagedPermissionsPermissionsOfGroupQueryKey(groupId)
         

         const query = useQuery({
          ...usersAuthzGetManagedPermissionsPermissionsOfGroupQueryOptions(groupId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UsersAuthzGetManagedPermissionsPermissionsOfGroup401 | UsersAuthzGetManagedPermissionsPermissionsOfGroup403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}